import { Card } from "reactstrap";
import TopHeader from "components/TopHeader/topHeader";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import downloadFile from "../../../functions/downloadFile";
import PaginationComponent from "components/Pagination/Pagination";
import useApi from "../../../apiHooks/apiHooks";
import TableLogs from "components/Table/TableLogs";
import NoData from "components/Others/NoData";
import Moment from "moment";

export default function EventLogs() {
    const [cookies, setCookie] = useCookies();
    const location = useLocation();
    const userRole = location.pathname.split("/")[1];
    const [eventLogs, setEventLogs] = useState(null);
    const { getAllEventLogs } = useApi();
    // Pagination
    const itemLimit = 10;
    const [dataShown, setDataShown] = useState(null);
    const [dataLength, setDataLength] = useState(0);
    const [numOfPages, setNumOfPages] = useState(1);
    const [initialCount, setInitialCount] = useState(0);
    const [page, setPage] = useState(1);

    const handlePageChange = (newPage) => {
        const from = newPage * itemLimit;
        const until = from + itemLimit;
        setDataShown(eventLogs.slice(from, until));
        setPage(newPage + 1);
        setInitialCount(newPage * itemLimit);
    };

    const handlePrevious = () => {
        const from = initialCount - itemLimit;
        const until = from + itemLimit;
        if (page > 1) {
            setDataShown(eventLogs.slice(from, until));
            setPage(page - 1);
            setInitialCount(initialCount - itemLimit);
        }
    };

    const handleNext = () => {
        const from = initialCount + itemLimit;
        const until = from + itemLimit;
        if (page < numOfPages) {
            setDataShown(eventLogs.slice(from, until));
            setPage(page + 1);
            setInitialCount(initialCount + itemLimit);
        }
    };

    // Get Event Logs
    const getEventLogs = async () => {
        let headers = {
            headers: {
                "auth-token": cookies.userToken,
            },
        };
        try {
            const response = await getAllEventLogs(headers);
            const logs = response.data.logs;
            // console.log(response.data.logs);
            setEventLogs(logs);
            setDataLength(logs.length);
            setDataShown(logs.slice(0, itemLimit));
        } catch (err) {
            const error = err.response;
            console.log(`err`, error);
        }
    };

    useEffect(() => {
        getEventLogs();
    }, []);

    useEffect(() => {
        if (dataLength > 0) setNumOfPages(dataLength / itemLimit);
    }, [dataLength]);

    const header = [
        "Location",
        "Submission Date",
        "Uploaded",
        "GTO Date",
        "Total Sum (w Tax)",
        "File",
    ];

    // Search Bar
    const [searchedData, setSearchedData] = useState(null);
    useEffect(() => {
        setSearchedData(dataShown);
    }, [dataShown]);

    const onSearch = (event) => {
        let keyword = event.target.value.toLowerCase();
        setSearchedData(
            eventLogs.filter((row) => {
                return (
                    row.Shop.location.toLowerCase().includes(keyword) ||
                    Moment(row.created_at)
                        .format("DD MMMM YYYY, h:mm a")
                        .toLowerCase()
                        .includes(keyword) ||
                    Moment(row.gto_date || row.created_at)
                        .format("DD MMMM YYYY")
                        .toLowerCase()
                        .includes(keyword)
                );
            })
        );
    };

    // Page Number Button Component
    let pageNumbers = [];
    for (var i = 0; i < numOfPages; i++) {
        pageNumbers.push(i);
    }

    return (
        <div className="m-5">
            <TopHeader title="Event Logs" searchBar onChange={onSearch} />
            <Card className="my-5 px-3">
                <TableLogs
                    header={header}
                    searchedData={searchedData}
                    downloadFile={downloadFile}
                />

                {(!eventLogs || searchedData?.length < 1) && (
                    <NoData text="No Event Logs Found" />
                )}
                <div className="mt-5">
                    <PaginationComponent
                        page={page}
                        handlePrevious={handlePrevious}
                        handleNext={handleNext}
                        handlePageChange={handlePageChange}
                        numOfPages={numOfPages}
                        pageNumbers={pageNumbers}
                    />
                </div>
            </Card>
        </div>
    );
}
